module.exports = "input[type=\"text\"], input[type=\"email\"], select, textarea{\n    background-color: white;\n}\nform input[type=\"submit\"]{opacity: 1; position: relative;}\n.mat-form-field {\n    display: inline;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/registration.component.css
// module id = ./src/app/registration/registration.component.css
// module chunks = main